import { BrandList } from "@/@types/Brand";
import { BrandListResponse } from "../../brands/models/BrandListResponse";

export function mapBrandList(response: BrandListResponse[]): BrandList[] {
    return response.map(data => ({
        title: data.title,
        logo: data.logo,
        slug: data.slug
    }));
}